import React, { useState, useEffect } from "react";
import { StaticImage } from "gatsby-plugin-image";
// import CiCLogo from "../images/CiC-Logo-1.webp";
// import HamburgerIcon from "../images/menu-icon.png";
import CloseButtonIcon from "../images/close_btn.svg";
import "./header.css";
import { Phone } from "lucide-react";
import Aos from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// import AniLink from "gatsby-plugin-transition-link/AniLink";
import { Link, navigate } from "gatsby";
import { useLocation } from "@reach/router";
// import { FaArrowDown } from "react-icons/fa";

import { RiArrowRightSLine } from "react-icons/ri";
// import { AccessibilityWidget } from 'react-accessibility'
import AccessibilityWidget from "./AccessibilityWidget/components/AccessibilityWidget";
import CSE from "./search";

// import BestWebLogo from "./BestwebLogo/BestWebLogo";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showDropDownMenu, setShowDropDownMenu] = useState("");

  //====================== Home Transition ========================//
  const [homeTransition, setHomeTransition] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const handleHomeTransition = (e, prop) => {
    let xPos = 0;

    if (typeof window !== "undefined") {
      if (window.innerWidth < 1100) {
        xPos = e.clientX;
      } else {
        xPos = e.clientX - 20;
      }
      const yPos = e.clientY;

      document.documentElement.style.setProperty("--xPos", `${xPos}px`);
      document.documentElement.style.setProperty("--yPos", `${yPos}px`);

      if (prop === "/home/") {
        if (currentPath === "/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/");
          }, 100);
        }
      } else if (prop === "/about-us/") {
        if (currentPath === "/about-us/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/about-us/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/about-us/");
          }, 700);
        }
      } else if (prop === "/our-segments/") {
        if (currentPath === "/our-segments/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/our-segments/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/our-segments/");
          }, 700);
        }
      } else if (prop === "/our-brands/") {
        if (currentPath === "/our-brands/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/our-brands/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/our-brands/");
          }, 700);
        }
      } else if (prop === "/media-room/") {
        if (currentPath === "/media-room/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/media-room/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/media-room/");
          }, 700);
        }
      } else if (prop === "/investor-desk/") {
        if (currentPath === "/investor-desk/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/investor-desk/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/investor-desk/");
          }, 700);
        }
      } else if (prop === "/sustainability/") {
        if (currentPath === "/sustainability/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/sustainability/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/sustainability/");
          }, 700);
        }
      } else if (prop === "/contact-us/") {
        if (currentPath === "/contact-us/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/contact-us/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/contact-us/");
          }, 700);
        }
      } else if (prop === "/careers-page/") {
        if (currentPath === "/careers-page/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/careers-page/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/careers-page/");
          }, 700);
        }
      } else if (prop === "/esg/") {
        if (currentPath === "/esg/") {
          setHomeTransition(false);
        } else {
          e.preventDefault();
          window.history.pushState({}, "", "/esg/");
          setHomeTransition(true);
          setTimeout(() => {
            navigate("/esg/");
          }, 700);
        }
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (homeTransition) {
        setHomeTransition(false);
      }
    }, 1000);
  }, [homeTransition]);

  // =================== End of Home Transition ==================== //

  const [navPadding, setNavPadding] = useState("10px 5px");
  const [isScrolled, setIsScrolled] = useState(false);
  const menuColor = isScrolled ? "#404040" : "#ffffff";

  const handleScroll = () => {
    if (typeof window !== "undefined") {
      if (window.scrollY > 50) {
        setNavPadding("3px 1px");
        setIsScrolled(true);
      } else {
        if (isMenuOpen) {
          setNavPadding("3px 1px");
          setIsScrolled(true);
        } else {
          setNavPadding("10px 5px");
          setIsScrolled(false);
        }
      }
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMobileMenuToggle = () => {
    setIsMenuOpen((prev) => !prev);
    if (isMenuOpen) {
      setNavPadding("3px 1px");
      setIsScrolled(true);
    }
  };

  useEffect(() => {
    Aos.init({ duration: 2000, easing: "ease-in-out" });
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   if (typeof window !== "undefined" && isMenuOpen) {
  //     window.scrollTo(100, 0);
  //   }
  // }, [isMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".dropdown-container") &&
        !event.target.closest(".dropdown-btn")
      ) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="main-content">
      <AccessibilityWidget />
      {/* <BestWebLogo /> */}
      <nav
        className={`nav-2 ${isScrolled ? "nav-scrolled" : "nav-top"}`}
        id="navbar"
        style={{ padding: navPadding }}
      >
        {homeTransition ? <div className="main-content-animation"></div> : null}
        <div className="logo-2">
          <a
            href="/"
            className="logo-22"
            data-aos="slide-right"
            data-aos-duration="500"
          >
            <StaticImage
              className="LogoC1"
              alt="Logo"
              src="https://sgp1.digitaloceanspaces.com/cic-react-redesign/images/header/CiC-Logo-1.webp"
              layout="constrained"
              formats={["auto", "webp", "avif"]}
              placeholder="none"
            />
          </a>
        </div>

        {isMenuOpen && (
          <>
            <div
              className="close-button"
              onClick={handleMobileMenuToggle}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleMobileMenuToggle();
                }
              }}
              role="button"
              tabIndex={0}
              aria-label="mobilemenu"
            >
              <img src={CloseButtonIcon} alt="Close Button" />
            </div>
          </>
        )}

        <ul className={`menu ${isMenuOpen ? "open" : ""}`}>
          <li
            className="lia testClass"
            data-aos="fade-down"
            data-aos-duration="100"
            data-aos-delay="50"
          >
            {/* <AniLink paintDrip to="/" hex="#001033">HOME</AniLink> */}
            <Link
              to="/"
              activeClassName="active"
              style={{ color: menuColor }}
              onClick={(e) => handleHomeTransition(e, "home")}
            >
              Home
            </Link>
          </li>
          {/*  */}
          <li
            className="menu-item dropdown"
            data-aos="fade-down"
            data-aos-duration="100"
            data-aos-delay="100"
          >
            <Link
              style={{ color: menuColor }}
              to="/about-us/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "about-us")}
              className="menu-link"
            >
              About Us
            </Link>
            <button
              className="mobile-nav-sub-menu-open-btn"
              onClick={() =>
                setShowDropDownMenu((prev) =>
                  prev !== "about-us" ? "about-us" : "",
                )
              }
              aria-label="dropdown menu"
            >
              <RiArrowRightSLine
                size={20}
                style={{
                  transform: `${
                    showDropDownMenu === "about-us"
                      ? "rotate(90deg)"
                      : "rotate(0deg)"
                  }`,
                }}
                className="mobile-nav-sub-menu-open-btn-icon"
              />
            </button>
            <ul
              className={`dropdown-menu ${
                showDropDownMenu === "about-us"
                  ? "show-drop-down"
                  : "hide-drop-down"
              }`}
            >
              <li>
                <Link
                  to="/about-us#about-cic"
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "one")}
                >
                  About CIC
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#about-future"
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Building a Better Future
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#about-values"
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Our Values
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#milestones"
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Milestones
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#board-of-directors"
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Board of Directors
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us#management-team"
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Management Team
                </Link>
              </li>
            </ul>
          </li>
          {/*  */}

          <li
            className="menu-item dropdown"
            data-aos="fade-down"
            data-aos-duration="100"
            data-aos-delay="150"
          >
            <Link
              style={{ color: menuColor }}
              to="/our-segments/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "/our-segments/")}
              className="menu-link"
            >
              Our Segments
            </Link>
            <button
              className="mobile-nav-sub-menu-open-btn"
              onClick={() =>
                setShowDropDownMenu((prev) =>
                  prev !== "our-segment" ? "our-segment" : "",
                )
              }
              aria-label="dropdown menu"
            >
              <RiArrowRightSLine
                size={20}
                style={{
                  transform: `${
                    showDropDownMenu === "our-segment"
                      ? "rotate(90deg)"
                      : "rotate(0deg)"
                  }`,
                }}
                className="mobile-nav-sub-menu-open-btn-icon"
              />
            </button>
            <ul
              className={`dropdown-menu ${
                showDropDownMenu === "our-segment"
                  ? "show-drop-down"
                  : "hide-drop-down"
              }`}
            >
              <li className="menu-item dropdown">
                <Link
                  style={{ color: menuColor }}
                  // to="/crop-solutions/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "two")}
                  className="menu-link"
                >
                  Crop Solutions
                </Link>
                <ul className="dropdown-menu sub-menu">
                  <li className="menu-item dropdown">
                    <Link
                      style={{ color: menuColor }}
                      to="/research-and-development/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-two")}
                    >
                      Research and Development (R & D)
                    </Link>
                    {/* <ul className="dropdown-menu sub-menu">
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/rice-research-laboratory/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-four")}
                          >
                            Rice Research and Development Laboratory
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/vegetable-and-corn/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-two")}
                          >
                            Vegetable and Corn
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/seed/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-two")}
                          >
                            Seed
                          </Link>
                        </li>
                      </ul> */}
                  </li>
                  <li className="menu-item">
                    <Link
                      style={{ color: menuColor }}
                      to="/seeds-and-planting/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-three")}
                    >
                      Seed and Plant
                    </Link>
                  </li>
                  <li className="menu-item dropdown">
                    <Link
                      style={{ color: menuColor }}
                      to="/plant-nutrition/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-one")}
                    >
                      Plant Nutrition
                    </Link>
                    <ul className="dropdown-menu sub-menu">
                      <li>
                        <Link
                          style={{ color: menuColor }}
                          to="/agri-speciality-inputs/"
                          activeClassName="active"
                          onClick={(e) => handleHomeTransition(e, "one-one")}
                        >
                          Speciality Agri Inputs
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item dropdown">
                    <Link
                      style={{ color: menuColor }}
                      to="/plant-protection/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-two")}
                    >
                      Plant Protection
                    </Link>
                    <ul className="dropdown-menu sub-menu">
                      <li>
                        <Link
                          style={{ color: menuColor }}
                          to="/crop-solution/"
                          activeClassName="active"
                          onClick={(e) => handleHomeTransition(e, "one-one")}
                        >
                          Crop Solution SBU
                        </Link>
                      </li>
                      <li>
                        <Link
                          style={{ color: menuColor }}
                          to="/crop-guard/"
                          activeClassName="active"
                          onClick={(e) => handleHomeTransition(e, "one-two")}
                        >
                          Crop Guard (pvt) Ltd
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item dropdown">
                    <Link
                      style={{ color: menuColor }}
                      to="/laboratory-services/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "three")}
                    >
                      Laboratory Services
                    </Link>
                    {/* <ul className="dropdown-menu sub-menu">
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/soil-plant-water/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-one")}
                          >
                            Soil, Plant and Water Analytical Laboratory
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/seeds-testing-laboratory/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-two")}
                          >
                            Seed Testing Laboratory
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/plant-tissue-culture/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-three")}
                          >
                            Plant Tissue Culture Laboratory
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ color: menuColor }}
                            to="/rice-research-laboratory/"
                            activeClassName="active"
                            onClick={(e) => handleHomeTransition(e, "one-four")}
                          >
                            Rice Research and Development Laboratory
                          </Link>
                        </li>
                      </ul> */}
                  </li>
                  <li className="menu-item">
                    <Link
                      style={{ color: menuColor }}
                      to="/digital-technology-service/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-five")}
                    >
                      Digital and Technology Services
                    </Link>
                  </li>
                  <li className="menu-item dropdown">
                    <Link
                      style={{ color: menuColor }}
                      to="/advisory-services/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-four")}
                    >
                      Advisory Services
                    </Link>
                  </li>
                  {/* <li>
                      <Link
                        style={{ color: menuColor }}
                        to="/cultivation-in-protected-environment/"
                        activeClassName="active"
                        onClick={(e) => handleHomeTransition(e, "one-three")}
                      >
                        Cultivation in a Protected Environment
                      </Link>
                    </li> */}
                  {/* <li>
                      <Link
                        style={{ color: menuColor }}
                        to="#"
                        activeClassName="active"
                        onClick={(e) => handleHomeTransition(e, "one-four")}
                      >
                        Corporate Social Responsibility
                      </Link>
                    </li> */}
                </ul>
              </li>

              <li className="menu-item dropdown">
                <Link
                  style={{ color: menuColor }}
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "one")}
                  className="menu-link"
                >
                  Agri Produce
                </Link>
                <ul className="dropdown-menu sub-menu">
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/quality-rice/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-one")}
                    >
                      Finest Rice
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/dairy-products/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-two")}
                    >
                      Dairy
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/fresh-produce/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-three")}
                    >
                      Fresh Produce
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/agri-holiday-resort/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-four")}
                    >
                      Agri Holiday Resort
                    </Link>
                  </li>
                  {/* <li>
                      <Link
                        style={{ color: menuColor }}
                        to="/quality-banana/"
                        activeClassName="active"
                        onClick={(e) => handleHomeTransition(e, "one-four")}
                      >
                        Quality banana
                      </Link>
                    </li> */}
                </ul>
              </li>
              <li className="menu-item dropdown">
                <Link
                  style={{ color: menuColor }}
                  // to="/livestock-solutions/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Live Stock
                </Link>
                <ul className="dropdown-menu sub-menu">
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/feeds/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-one")}
                    >
                      Feeds
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/poultry/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-two")}
                    >
                      Poultry
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/vet-care/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-three")}
                    >
                      Vetcare
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item dropdown">
                <Link
                  style={{ color: menuColor }}
                  // to="/health-care/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Health and Personal Care
                </Link>
                <ul className="dropdown-menu sub-menu">
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/herbal-and-personal-care/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-one")}
                    >
                      Herbal Health Care and Personal Care
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/medical-devices/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-two")}
                    >
                      Medical Devices
                    </Link>
                  </li>
                  <li>
                    <Link
                      style={{ color: menuColor }}
                      to="/pharmaceuticals/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-three")}
                    >
                      Pharmaceuticals & Pharmaceutical Manufacturing
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="menu-item dropdown">
                <Link
                  style={{ color: menuColor }}
                  // to="/industrial-solutions/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Industrial Solution
                </Link>
                <ul className="dropdown-menu sub-menu">
                  <li className="menu-item dropdown">
                    <Link
                      style={{ color: menuColor }}
                      // to="/raw-material-and-process-chemical/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-one")}
                    >
                      Raw Material and Process chemical
                    </Link>
                    <ul className="dropdown-menu sub-menu">
                      <li>
                        <Link
                          style={{ color: menuColor }}
                          to="/industrial-chemical/"
                          activeClassName="active"
                          onClick={(e) => handleHomeTransition(e, "one-one")}
                        >
                          Industrial Chemicals
                        </Link>
                      </li>
                      <li>
                        <Link
                          style={{ color: menuColor }}
                          to="/nalco-water/"
                          activeClassName="active"
                          onClick={(e) => handleHomeTransition(e, "one-two")}
                        >
                          Nalco Water
                        </Link>
                      </li>
                      <li>
                        <Link
                          style={{ color: menuColor }}
                          to="/chemanex/"
                          activeClassName="active"
                          onClick={(e) => handleHomeTransition(e, "one-two")}
                        >
                          Chemanex
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item">
                    <Link
                      style={{ color: menuColor }}
                      to="/construction-material/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-two")}
                    >
                      Construction Material
                    </Link>
                  </li>
                  <li className="menu-item">
                    <Link
                      style={{ color: menuColor }}
                      to="/speciality-packaging/"
                      activeClassName="active"
                      onClick={(e) => handleHomeTransition(e, "one-three")}
                    >
                      Speciality Packaging(PET Bottle)
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          {/* <li
              data-aos="fade-down"
              data-aos-duration="250"
              data-aos-delay="700"
            >
              <Link
                style={{ color: menuColor }}
                to="/our-brands/"
                activeClassName="active"
                onClick={(e) => handleHomeTransition(e, "our-brands")}
              >
                Our Brands
              </Link>
            </li> */}

          {/*  */}
          <li
            className="menu-item dropdown"
            data-aos="fade-down"
            data-aos-duration="100"
            data-aos-delay="200"
          >
            <Link
              style={{ color: menuColor }}
              to="/sustainability/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "sustainability")}
              className="menu-link"
            >
              Sustainability
            </Link>
            {/* <button
                className="mobile-nav-sub-menu-open-btn"
                onClick={() =>
                  setShowDropDownMenu((prev) =>
                    prev !== "sustainability" ? "sustainability" : ""
                  )
                }
                aria-label="drop down menu"
              >
                <RiArrowRightSLine
                  size={20}
                  style={{
                    transform: `${
                      showDropDownMenu === "sustainability"
                        ? "rotate(90deg)"
                        : "rotate(0deg)"
                    }`,
                  }}
                  className="mobile-nav-sub-menu-open-btn-icon"
                />
              </button> */}
            {/* <ul
                className={`dropdown-menu ${
                  showDropDownMenu == "sustainability"
                    ? "show-drop-down"
                    : "hide-drop-down"
                }`}
              > */}
            {/* <li className="menu-item dropdown">
                  <Link
                    style={{ color: menuColor }}
                    activeClassName="active"
                    onClick={(e) => handleHomeTransition(e, "three")}
                  >
                    Research and Development
                  </Link>
                  <ul className="dropdown-menu sub-menu">
                    <li>
                      <Link
                        style={{ color: menuColor }}
                        to="/soil-plant-water/"
                        activeClassName="active"
                        onClick={(e) => handleHomeTransition(e, "one-one")}
                      >
                        Soil, Plant and Water Analytical Laboratory
                      </Link>
                    </li>
                    <li>
                      <Link
                        style={{ color: menuColor }}
                        to="/seeds-testing-laboratory/"
                        activeClassName="active"
                        onClick={(e) => handleHomeTransition(e, "one-two")}
                      >
                        Seed Testing Laboratory
                      </Link>
                    </li>
                    
                    <li>
                      <Link
                        style={{ color: menuColor }}
                        to="/rice-research-laboratory/"
                        activeClassName="active"
                        onClick={(e) => handleHomeTransition(e, "one-four")}
                      >
                        Rice Research and Development Laboratory
                      </Link>
                    </li>
                  </ul>
                </li> */}
            {/* <li>
                  <Link
                    style={{ color: menuColor }}
                    to="/corporate-social-responsibility/"
                    activeClassName="active"
                    onClick={(e) => handleHomeTransition(e, "six")}
                  >
                    Corporate Social Responsibility
                  </Link>
                </li> */}
            {/* </ul> */}
          </li>
          {/*  */}

          <li data-aos="fade-down" data-aos-duration="100" data-aos-delay="250">
            <Link
              // paintDrip
              // hex="#001033"
              style={{ color: menuColor }}
              to="/esg/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "esg")}
            >
              ESG
            </Link>
          </li>

          {/*  */}
          <li
            className="menu-item dropdown"
            data-aos="fade-down"
            data-aos-duration="100"
            data-aos-delay="300"
          >
            <Link
              style={{ color: menuColor }}
              to="/media-room/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "media-room")}
              className="menu-link"
            >
              Media Room
            </Link>
            <button
              className="mobile-nav-sub-menu-open-btn"
              onClick={() =>
                setShowDropDownMenu((prev) =>
                  prev !== "media-room" ? "media-room" : "",
                )
              }
              aria-label="dropdown menu"
            >
              <RiArrowRightSLine
                size={20}
                style={{
                  transform: `${
                    showDropDownMenu === "media-room"
                      ? "rotate(90deg)"
                      : "rotate(0deg)"
                  }`,
                }}
                className="mobile-nav-sub-menu-open-btn-icon"
              />
            </button>
            <ul
              className={`dropdown-menu ${
                showDropDownMenu === "media-room"
                  ? "show-drop-down"
                  : "hide-drop-down"
              }`}
            >
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/press-release/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "two")}
                >
                  Press Release
                </Link>
              </li>
              {/* <li>
                  <Link
                    style={{ color: menuColor }}
                    to="/corporate-event/"
                    activeClassName="active"
                    onClick={(e) => handleHomeTransition(e, "three")}
                  >
                    Corporate Events
                  </Link>
                </li> */}
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/awards/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Awards
                </Link>
              </li>
            </ul>
          </li>
          {/*  */}

          {/*  */}
          <li
            className="menu-item dropdown"
            data-aos="fade-down"
            data-aos-duration="100"
            data-aos-delay="350"
          >
            <Link
              style={{ color: menuColor }}
              to="/investor-desk/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "investor-desk")}
              className="menu-link"
            >
              Investor Desk
            </Link>
            <button
              className="mobile-nav-sub-menu-open-btn"
              onClick={() =>
                setShowDropDownMenu((prev) =>
                  prev !== "investor-desk" ? "investor-desk" : "",
                )
              }
              aria-label="dropdown menu"
            >
              <RiArrowRightSLine
                size={20}
                style={{
                  transform: `${
                    showDropDownMenu === "investor-desk"
                      ? "rotate(90deg)"
                      : "rotate(0deg)"
                  }`,
                }}
                className="mobile-nav-sub-menu-open-btn-icon"
              />
            </button>
            <ul
              className={`dropdown-menu ${
                showDropDownMenu === "investor-desk"
                  ? "show-drop-down"
                  : "hide-drop-down"
              }`}
            >
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/financial-highlights/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "two")}
                >
                  Financial Highlights
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/market-capitalization/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Market Capitalization
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/investor-information/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Investor Information
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/dividend-information/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Dividend Information
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/share-information/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Share Information
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/analyst-coverage/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Analyst Coverage
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/corporate-information/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Corporate Information
                </Link>
              </li>
              <li>
                <Link
                  style={{ color: menuColor }}
                  to="/reports-and-presentation/"
                  activeClassName="active"
                  onClick={(e) => handleHomeTransition(e, "three")}
                >
                  Reports and Presentations
                </Link>
              </li>
            </ul>
          </li>
          {/*  */}

          <li data-aos="fade-down" data-aos-duration="100" data-aos-delay="400">
            {/* <AniLink paintDrip to="/about-us/" hex="#001033">ABOUT US</AniLink> */}
            <Link
              to="/careers-page/"
              activeClassName="active"
              style={{ color: menuColor }}
              onClick={(e) => handleHomeTransition(e, "careers-page")}
            >
              Careers
            </Link>
          </li>

          <li data-aos="fade-down" data-aos-duration="100" data-aos-delay="450">
            <Link
              // paintDrip
              // hex="#001033"
              style={{ color: menuColor }}
              to="/contact-us/"
              activeClassName="active"
              onClick={(e) => handleHomeTransition(e, "contact-us")}
            >
              <Phone />
            </Link>
          </li>

          <li className="search-box">
            <CSE />
          </li>
        </ul>

        <div className="hamburger-img">
          <img
            className="mobileIcon"
            onClick={handleMobileMenuToggle}
            src="https://sgp1.digitaloceanspaces.com/cic-react-redesign/images/header/menu-icon.png"
            alt="Menu"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleMobileMenuToggle();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="mobile menu"
          />
        </div>
      </nav>
    </div>
  );
};

export default Header;
